import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, Switch, Radio, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import CoreUtilities from "../util";
import useLocalStorage from "../hooks/useLocalStorage";
import { USER_TASK_ENVIRONMENTS } from "../constants";

function HomePage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [widgetSetting, setWidgetSettings] = useLocalStorage(
    "widgetSetting",
    null
  );

  useEffect(() => {
    if (widgetSetting) {
      form.setFieldsValue(widgetSetting);
    }
  }, [widgetSetting, form]);

  const onsave = () => {
    form.submit();
  };

  const handleUserTaskEnv = (value) => {
    const env = value.toUpperCase();
    return USER_TASK_ENVIRONMENTS[env];
  };

  const onWidgetEnvChange = (e) => {
    const widgetConfig = handleUserTaskEnv(e.target.value);

    form.setFieldValue("endPoint", widgetConfig.url);
    form.setFieldValue("organizationId", widgetConfig.tenant_id);
    form.setFieldValue("appId", widgetConfig.app_id);
  };

  const onSubmit = (values) => {
    setLoading(true);

    const widgetConfig = handleUserTaskEnv(values.userTaskEnv);
    CoreUtilities.wait(3000);
    const token = CoreUtilities.generateJWTToken(
      widgetConfig.app_id,
      widgetConfig.tenant_id,
      widgetConfig.roles,
      widgetConfig.scope,
      widgetConfig.user_id,
      "",
      widgetConfig.tokenSecret
    );
    const settigns = {
      userTaskEnv: values.userTaskEnv,
      token,
      showTitle: values.showTitle,
      endPoint: widgetConfig.url,
      hideTabs: values.hideTabs,
      hideFilter: values.hideFilter,
      organizationId: widgetConfig.tenant_id,
      appId: widgetConfig.app_id,
      environment: values.userTaskEnv,
      appsyncGraphqlEndpoint: widgetConfig.appsyncGraphqlEndpoint,
      customFormsUrl: widgetConfig.customFormsUrl,
      widgetHost: widgetConfig.widgetHost,
    };
    setWidgetSettings(settigns);

    CoreUtilities.Notify(
      "success",
      "Success",
      "Configuration Saved Successfully"
    );
    CoreUtilities.wait(3000);
    setLoading(false);

    navigate("/user-tasks");
  };

  return (
    <div className="widget-div">
      <Card
        title="User Task Widget Configuration"
        bordered={true}
        className="core-form"
        extra={
          <Button
            type="primary"
            style={{ color: "#FFF", backgroundColor: "rgb(225, 126, 37)" }}
            htmlType="submit"
            onClick={onsave}
            loading={loading}
          >
            Save
          </Button>
        }
      >
        <Form
          form={form}
          name="core-form"
          layout="horizontal"
          onFinish={onSubmit}
          // validateMessages={FORM_VALIDATION_MESSAGES}
        >
          <Row>
            <Col span={16}>
              <Form.Item
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 6 }}
                name="userTaskEnv"
                label="Widget Env"
                rules={[
                  {
                    required: true,
                    message: "Please select User Tasks Widget Env",
                  },
                ]}
              >
                <Radio.Group onChange={onWidgetEnvChange}>
                  <Radio.Button value="qa">QA</Radio.Button>
                  <Radio.Button value="dev">Dev</Radio.Button>
                  <Radio.Button value="local">Local</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <Form.Item
                labelCol={{ span: 6 }}
                name="endPoint"
                label=" Service"
              >
                <Input
                  disabled={true}
                  placeholder="Enter User Task Service Url"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={16}>
              <Form.Item
                labelCol={{ span: 6 }}
                name="organizationId"
                label="Organization Id"
              >
                <Input disabled={true} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <Form.Item name="appId" labelCol={{ span: 6 }} label="App Id">
                <Input disabled={true} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={4} style={{ textAlign: "right", paddingTop: "5px" }}>
              <label>Widget UI Settings: &nbsp;&nbsp;</label>
            </Col>
            <Col span={4}>
              <Form.Item
                //labelCol={{ span: 12 }}
                labelAlign="right"
                label="Show Tile"
                name="showTitle"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Show Tabs"
                name="hideTabs"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                //labelCol={{ span: 12 }}
                labelAlign="right"
                label="Show Filters"
                name="hideFilter"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default HomePage;
